var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',_vm._l((_vm.list),function(item){return _c('b-col',{key:item.id,staticClass:"mb-4",attrs:{"md":"4"}},[_c('ProductCard',{attrs:{"img":item.img,"name":item.name},on:{"click":function($event){return _vm.$emit('select', item.id)}}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }